/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import {
  getSocialVideoChannels,
  getSocialVideos,
} from '@apps/config/API/social-video.config';
import { Breadcrumb } from '@stack/ui/components';
import { BreadCrumbOptions } from '@stack/ui/components/Breadcrumb/props';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';

import { SocialVideoScreen } from '../screens/SocialVideo/index';

/**
 * ===========================
 * MAIN
 * ===========================
 */
const Page: NextPage = (props) => {
  const { data } = props;
  const router = useRouter();
  const { t } = useTranslation('common');
  const currentPath = router?.query?.category;
  const [ct, setCT] = useState<string>('');
  const [ps, setPS] = useState<number>(12);
  const [videos, setVideos] = useState<any>(null);
  const { ref, inView } = useInView({
    initialInView: true,
  });
  const [loading, setLoading] = useState(false);

  // ======================= API
  const fetchData = async (pageSize: number) => {
    try {
      setLoading(true);
      const videosData = await getSocialVideos({
        channelId: ct ?? '',
        pageSize: 12,
        page: pageSize,
      });
      setPS(pageSize);

      setLoading(false);
      const stateTik = videos?.tiktok ?? [];
      const stateYT = videos?.youtube ?? [];

      setVideos({
        tiktok: [...stateTik, ...videosData.tiktok],
        youtube: [...stateYT, ...videosData.youtube],
      });
      return videosData;
    } catch (err) {
      console.log('err', err);
    }
  };

  useEffect(() => {
    setVideos(null);
    fetchData(1);
  }, [ct]);

  const loadMoreUsers = async () => {
    const apiRes = await fetchData(ps + 1);
    const stateTik = videos?.tiktok || [];
    const stateYT = videos?.youtube || [];

    setVideos({
      tiktok: [...stateTik, ...apiRes.tiktok],
      youtube: [...stateYT, ...apiRes.youtube],
    });
  };

  const handleCTChange = async (inCT: any) => {
    if (inCT === ct) return;
    setVideos(null);
    setCT(inCT);
    setPS(1);
  };

  useEffect(() => {
    if (ct === '' || ct === undefined) return;
    if (inView) {
      loadMoreUsers();
    }
  }, [inView]);

  const breadcrumbOpt: BreadCrumbOptions[] = [
    {
      title: t('news'),
      url: '/',
    },
    {
      title: t('socialVideo'),
    },
  ];

  return (
    <>
      <div>
        <Breadcrumb options={breadcrumbOpt} />
        <h1>{currentPath}</h1>
        <SocialVideoScreen
          data={{ channels: data.channels, videos: videos }}
          setChannelType={handleCTChange}
          loading={loading}
        />
        {videos && ct !== '' && (
          <div
            ref={ref}
            style={{
              visibility: 'hidden',
            }}
          >
            Loading...
          </div>
        )}
      </div>
    </>
  );
};

// ==============================
// SERVER SIDE
// ==============================

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getServerSideProps = async (ctx: any) => {
  const channelType = ctx?.query?.channel ?? '';
  const socialVideoPageSize = ctx?.query?.socialVideoPageSize ?? 12;

  const channelsData = await getSocialVideoChannels();
  const videosData = await getSocialVideos({
    channelId: channelType,
    pageSize: socialVideoPageSize,
  });

  return {
    props: {
      data: {
        channels: channelsData?.data || [],
        videos: videosData || [],
      },
    },
  };
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default Page;
